import * as Types from '../generated/graphql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetAppendixCodeSectionsQueryVariables = Types.Exact<{
  codeBookId: Types.Scalars['uuid']['input'];
  appendixNumber: Types.Scalars['String']['input'];
  limit?: Types.InputMaybe<Types.Scalars['Int']['input']>;
}>;


export type GetAppendixCodeSectionsQuery = { __typename?: 'query_root', code_sections: Array<{ __typename?: 'code_sections', id: any, section_number: string, title?: string | null, body: string, page_number?: number | null, depth: number }> };


export const GetAppendixCodeSectionsDocument = gql`
    query getAppendixCodeSections($codeBookId: uuid!, $appendixNumber: String!, $limit: Int = 500) {
  code_sections(
    where: {code_book_id: {_eq: $codeBookId}, chapter_number: {_eq: $appendixNumber}, section_number: {_neq: $appendixNumber}}
    order_by: {sort_key: asc}
    limit: $limit
  ) {
    id
    section_number
    title
    body
    page_number
    depth
  }
}
    `;

/**
 * __useGetAppendixCodeSectionsQuery__
 *
 * To run a query within a React component, call `useGetAppendixCodeSectionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAppendixCodeSectionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAppendixCodeSectionsQuery({
 *   variables: {
 *      codeBookId: // value for 'codeBookId'
 *      appendixNumber: // value for 'appendixNumber'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetAppendixCodeSectionsQuery(baseOptions: Apollo.QueryHookOptions<GetAppendixCodeSectionsQuery, GetAppendixCodeSectionsQueryVariables> & ({ variables: GetAppendixCodeSectionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAppendixCodeSectionsQuery, GetAppendixCodeSectionsQueryVariables>(GetAppendixCodeSectionsDocument, options);
      }
export function useGetAppendixCodeSectionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAppendixCodeSectionsQuery, GetAppendixCodeSectionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAppendixCodeSectionsQuery, GetAppendixCodeSectionsQueryVariables>(GetAppendixCodeSectionsDocument, options);
        }
export function useGetAppendixCodeSectionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAppendixCodeSectionsQuery, GetAppendixCodeSectionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAppendixCodeSectionsQuery, GetAppendixCodeSectionsQueryVariables>(GetAppendixCodeSectionsDocument, options);
        }
export type GetAppendixCodeSectionsQueryHookResult = ReturnType<typeof useGetAppendixCodeSectionsQuery>;
export type GetAppendixCodeSectionsLazyQueryHookResult = ReturnType<typeof useGetAppendixCodeSectionsLazyQuery>;
export type GetAppendixCodeSectionsSuspenseQueryHookResult = ReturnType<typeof useGetAppendixCodeSectionsSuspenseQuery>;
export type GetAppendixCodeSectionsQueryResult = Apollo.QueryResult<GetAppendixCodeSectionsQuery, GetAppendixCodeSectionsQueryVariables>;